import { DialogUI } from '../Interface';
import { useSimpleTask } from '../../hooks/useSimpleTask';
import { useEffect, useState } from 'react';
import { SimpleTaskForm } from '../NewSimpleTask/SimpleTaskForm';

const SimpleTaskDialog = ({ handleClose, changed, dialogData }) => {
  const { open, data } = dialogData;
  const { taskChanged, setTaskChanged } = changed;
  const simpleTaskState = useSimpleTask();

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      simpleTaskState.setSelectedValues(data);
    }
  }, [data, simpleTaskState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Feladat módosítása'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <div className="mt-5">
        <SimpleTaskForm
          dialog={{
            handleClose: handleClose,
            taskChanged: taskChanged,
            setTaskChanged: setTaskChanged,
            isUpdate: true,
          }}
          simpleTaskState={simpleTaskState}
        />
      </div>
    </DialogUI>
  );
};

export default SimpleTaskDialog;
